// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"8487":"css/admin-app.7023","9495":"css/app.7023"}[chunkId] + ".css";
};